// extracted by mini-css-extract-plugin
module.exports = {"recommendationsBlock":"styles_recommendationsBlock__0RJbK","title":"styles_title__7Gf8Q","slide":"styles_slide__NDfzh"};